<template>
  <div class="input-field"
      :class="{ 'input-field--readonly': this.readonly,
                'input-field--disabled': this.disabled,
                'input-field--vertical': this.vertical,
                'input-field--stretch': this.stretch }">
        <textarea v-if="inputOut"
          v-bind="$attrs"
          :id="id"
          v-model="modelValue"
          :placeholder="placeholder"
          :readonly="readonly"
          :disabled="disabled"
          v-on="inputListeners"
          v-autosize>
        </textarea>
        <textarea v-else
          v-bind="$attrs"
          :id="id"
          :value="value"
          :placeholder="placeholder"
          :readonly="readonly"
          :disabled="disabled"
          v-on="inputListeners"
          v-autosize>
        </textarea>
      <label :for="id" class="input-field__label-textarea" :class="{'input-field__label-textarea--active': labelActive && this.vertical}">
        <slot></slot>
      </label>
      <slot name="helper"></slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      required: false
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    stretch: {
      type: Boolean,
      required: false
    },
    vertical: {
      type: Boolean,
      required: false
    },
    inputOut: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      labelActive: false,
      modelValue: this.value
    }
  },
  mounted() {
    if (this.value || this.placeholder != null) {
      this.labelActive = true
    }
    if (this.inputOut && !this.value) {
      this.modelValue = this.value
    }
  },
  updated() {
    this.$nextTick(function () {
      if (this.value) {
        this.labelActive = true
      }
    })
  },
  computed: {
    inputListeners: function () {
      var vm = this
      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            vm.$emit('input', event.target.value)
          },
          focus: function (event) {
            if (!vm.readonly) {
              vm.labelActive = true
            }
          },
          blur: function (event) {
            if (!event.target.value && vm.placeholder == null) {
              vm.labelActive = false
            }
          }
        }
      )
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/TextareaField.vue